export default "./media/marker_hibernated-24ded3bdf57f4fa4d98a889223adf734.png";